import { defineMessages } from 'react-intl';

export const shipmentSummarySectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Shipment Summary',
    id: 'RllHuP',
    description: 'Title of the shipment summary card in the freight details view',
  },
  carrierService: {
    defaultMessage: '{carrier} - {service}',
    id: 'jCp1Ai',
    description: 'Carrier name and service level on one line',
  },
  arrives: {
    defaultMessage: 'Arrives {date}',
    id: 'lUKwbo',
    description: 'Estimated delivery date line in the shipment summary',
  },
  total: {
    defaultMessage: 'Total',
    id: 'wAWRyX',
    description: 'Label for the total cost in the cost breakdown accordion',
  },
  costDisclaimer: {
    defaultMessage: 'Final amount may vary. Post-shipment adjustments are common with LTL.',
    id: 'BpcXEc',
    description: 'Fine print under the freight cost breakdown',
  },
  invoiceTitle: {
    defaultMessage: 'Invoice details',
    id: 'WqCecN',
    description: 'Heading for the invoice details block in the shipment summary',
  },
  invoiceCopy: {
    defaultMessage: 'Invoice sent after shipment.',
    id: 'Vsk7kt',
    description: 'Static copy explaining when the invoice is sent',
  },
  manageBilling: {
    defaultMessage: 'View and manage your billing',
    id: 'WJ3jWF',
    description: 'Link to the billing management page',
  },
});
